import { isEmptyString, isNullable } from '@app/utils'

import type { DropdownMenuItem } from '@app/types/dropdown'

export const getFilteredItemsBySearchValue = (items: DropdownMenuItem[], searchValue?: string): DropdownMenuItem[] => {
  if (!isNullable(searchValue) && !isEmptyString(searchValue)) {
    return items.filter(item => item.label?.toLowerCase().includes(searchValue.toLowerCase()))
  }

  return items
}
